import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-plus\"><path fill-rule=\"evenodd\" d=\"M8.64.667c.113 0 .17.054.17.163v6.395l6.353.001c.114 0 .17.054.17.163V8.61c0 .109-.056.163-.17.163H8.81v6.396c0 .109-.057.163-.17.163H7.36c-.113 0-.17-.054-.17-.163V8.774H.836c-.113 0-.17-.054-.17-.163V7.39c0-.109.057-.163.17-.163H7.19V.83c0-.109.058-.163.171-.163h1.28z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol